import React from 'react'
import NewWindow from 'react-new-window'

import { Typography } from '@material-ui/core'

import { DateConversions } from '../utils/DateConversions'

/**
 * Show a sign in sheet for an Event. The caller must pass the following props:
 *  - windowClosed: function to call when the window is closed
 *  - windowBlocked: function to call when the window is blocked by the browser
 *  - event: Event object
 */


const PRINT_DELAY = 3000; //ms

export const EventSigninSheet = (props) => {
 
    const styles = {
        table: {
            borderCollapse: 'collapse',
            width: '100%',
            marginBottom: 20,
            marginTop: 10
        },
        tableHeader: {
            borderBottom: '2px solid gray',
            textAlign: 'left',
            padding: 5,
            paddingRight: 10,
            marginBottom: 8,
            fontSize: 12,
            fontWeight: 'normal',
            textTransform: 'uppercase'
        },
        tableData: {
            borderBottom: '1px solid lightGray',
            textAlign: 'left',
            fontSize: 12,
            padding: 5,
            paddingRight: 10,
            paddingTop: 6,
            paddingBottom: 6
        }
    };

    const header = "Sign-In Sheet for " + props.event.title + " on " + DateConversions.dateTimeStr(props.event.start);

    // Combine manual signups and patron signups into a single list
    const patrons = [...props.event.manualSignups, ...props.event.patronSignups];

    const patronNames = (patron) => {
        const {names, blankText} = patron.getCommaSeparatedNames();
        return names + blankText;
    }

    const patronRow = patrons.map(patron => ({count: patron.patronCount, 
                                                          names: patronNames(patron), 
                                                          email: patron.patronEmail, 
                                                          additionalPurchases: patron.getAdditionalPurchases()
                                                        }));

    // Sort patron row by names alphabetically
    patronRow.sort((a, b) => a.names.localeCompare(b.names));

    return (
        <NewWindow title={props.event.title + " Sign-in Sheet"} name="Sign in Sheet" 
                   onUnload={props.windowClosed} onBlock={props.windowBlocked}
                   onOpen={(window) => {setTimeout(() => {window.print();}, PRINT_DELAY);}}
                   features={{width: 1000, height: 768}}>
                   
            <Typography variant="h6" style={{textAlign: 'center', marginBottom: 20}}>{header}</Typography>
            
             <table style={styles.table}>
                <thead>
                    <tr>
                        <th style={styles.tableHeader}>Sign-In</th>
                        <th style={styles.tableHeader}>Patron Count</th>
                        <th style={styles.tableHeader}>Names</th>
                        <th style={styles.tableHeader}>Email</th>
                        <th style={styles.tableHeader}>Optional Purchases</th>
                    </tr>
                </thead>
                <tbody>
                    {patronRow.map((row, index) => 
                        <tr key={index}> 
                            <td style={styles.tableData}>
                                <div style={{border: '1px solid black', padding: 5, width: 30, height: 30}}/>
                            </td>          
                            <td style={styles.tableData}>{row.count}</td>
                            <td style={styles.tableData}>{row.names}</td>
                            <td style={styles.tableData}>{row.email}</td>
                            <td style={styles.tableData}>{row.additionalPurchases}</td>
                        </tr>
                    )}
                </tbody>
            </table>
            
        </NewWindow>
    );
};
    